module.exports = __webpack_public_path__ + "Octopus.87d099af4960c9e52db0ca1ba0b9718c.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/img/getting-started/animation/Octopus.svg
// module id = 5393966393052343
// module chunks = 1